import { api } from "@/lib/api";

// Schedule
export const getCourseSchedule = (courseId) =>
  api.get(`/courses/${courseId}/schedule`).then((r) => r.data);
export const saveCourseSchedule = (courseId, body) =>
  api.post(`/courses/${courseId}/schedule`, body).then((r) => r.data);
export const deleteCourseSchedule = (courseId) =>
  api.delete(`/courses/${courseId}/schedule`).then((r) => r.data);

// Sessions per-course
export const listCourseSessions = (courseId, params) =>
  api.get(`/courses/${courseId}/sessions`, { params }).then((r) => r.data);
export const createAdhocSession = (courseId, body) =>
  api.post(`/courses/${courseId}/sessions`, body).then((r) => r.data);
export const updateSession = (sessionId, patch) =>
  api.put(`/sessions/${sessionId}`, patch).then((r) => r.data);
export const deleteSession = (sessionId) =>
  api.delete(`/sessions/${sessionId}`).then((r) => r.data);
export const startSession = (sessionId) =>
  api.post(`/sessions/${sessionId}/start`).then((r) => r.data);
export const completeSession = (sessionId) =>
  api.post(`/sessions/${sessionId}/complete`).then((r) => r.data);
export const joinSession = (sessionId) =>
  api.get(`/sessions/${sessionId}/join`).then((r) => r.data);

// Calendar / admin
export const getMyCalendar = (params) =>
  api.get(`/me/calendar`, { params }).then((r) => r.data);
export const adminListSessions = (params) =>
  api.get(`/admin/sessions`, { params }).then((r) => r.data);

// ---- helpers ----

export const PRESETS = [
  { value: "twice_weekday", label: "Twice in a weekday (Mon–Fri, 10:00 & 16:00)" },
  { value: "once_weekend", label: "Once on weekend (Sat 11:00)" },
  { value: "custom", label: "Custom slots" },
];

export const DAY_NAMES = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export const TIMEZONES = [
  { value: "Asia/Kolkata", label: "Asia/Kolkata (IST)" },
  { value: "UTC", label: "UTC" },
  { value: "America/New_York", label: "America/New_York (ET)" },
  { value: "America/Los_Angeles", label: "America/Los_Angeles (PT)" },
  { value: "Europe/London", label: "Europe/London (GMT/BST)" },
  { value: "Europe/Berlin", label: "Europe/Berlin (CET)" },
];

export const SESSION_TYPES = [
  { value: "classwork", label: "Classwork", color: "amber" },
  { value: "test", label: "Test", color: "red" },
  { value: "general", label: "General", color: "stone" },
];

export const typeColor = (t) =>
  ({ classwork: "amber", test: "red", general: "stone" }[t] || "stone");

// Tailwind classes per session_type for badges
export const typeBadge = (t) =>
  ({
    classwork: "bg-amber-50 text-amber-900 border-amber-300",
    test: "bg-red-50 text-red-900 border-red-300",
    general: "bg-stone-100 text-stone-700 border-stone-300",
  }[t] || "bg-stone-100 text-stone-700 border-stone-300");

// react-big-calendar event background colour per session_type
export const typeEventBg = (t) =>
  ({
    classwork: "#d97706", // amber-600
    test: "#dc2626", // red-600
    general: "#57534e", // stone-600
  }[t] || "#57534e");

export const statusBadge = (s) =>
  ({
    scheduled: "bg-stone-100 text-stone-700 border-stone-300",
    live: "bg-emerald-50 text-emerald-800 border-emerald-300 animate-pulse",
    completed: "bg-zinc-100 text-zinc-700 border-zinc-300",
    cancelled: "bg-red-50 text-red-700 border-red-300",
  }[s] || "bg-stone-100 text-stone-700 border-stone-300");

/** ±15 min join window relative to session start. */
export const isJoinable = (session) => {
  if (!session) return false;
  if (session.status === "cancelled" || session.status === "completed") return false;
  const start = new Date(session.starts_at).getTime();
  const end = new Date(session.ends_at).getTime();
  const now = Date.now();
  const FIFTEEN = 15 * 60 * 1000;
  return now >= start - FIFTEEN && now <= end + FIFTEEN;
};

/** Format a UTC iso into local time short string. */
export const fmtDateTime = (iso) =>
  new Date(iso).toLocaleString(undefined, {
    weekday: "short",
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });

export const fmtTime = (iso) =>
  new Date(iso).toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
  });

export const fmtDate = (iso) =>
  new Date(iso).toLocaleDateString(undefined, {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

/** Return the slots arrays for a preset. */
export const presetSlots = (preset) => {
  if (preset === "twice_weekday") {
    const out = [];
    for (let d = 0; d <= 4; d++) {
      out.push({ day_of_week: d, start_time: "10:00", duration_minutes: 60 });
      out.push({ day_of_week: d, start_time: "16:00", duration_minutes: 60 });
    }
    return out;
  }
  if (preset === "once_weekend") {
    return [{ day_of_week: 5, start_time: "11:00", duration_minutes: 90 }];
  }
  return [];
};
